import { PermissionScoreType } from './types';

export const PERMISSION_TYPE_ALL = 'all';
export const PERMISSION_TYPE_OWNER = 'owner';
export const PERMISSION_TYPE_ASSIGNEE = 'assignee';
export const PERMISSION_TYPE_PROJECT = 'project';
export const PERMISSION_TYPE_SELF = 'self';

export const PERMISSION_GROUP_TASK = 'schedule-task';
export const PERMISSION_GROUP_WORK_ITEM = 'work-item';
export const PERMISSION_GROUP_PROJECT = 'projects';
export const PERMISSION_GROUP_USER = 'users';
export const PERMISSION_GROUP_FILES = 'files';
export const PERMISSION_GROUP_SETTINGS = 'settings';
export const PERMISSION_GROUP_DRAWING = 'drawing';
export const PERMISSION_GROUP_DOCUMENTS = 'documents';
export const PERMISSION_GROUP_CATEGORIES = 'categories';

export const PERMISSION_ACTION_CREATE = 'create';
export const PERMISSION_ACTION_VIEW = 'view';
export const PERMISSION_ACTION_MANAGE = 'manage';
export const PERMISSION_ACTION_EDIT = 'edit';

export const permissionScoreData: PermissionScoreType = {
    group: {
        [PERMISSION_GROUP_TASK]: 10000,
        [PERMISSION_GROUP_WORK_ITEM]: 20000,
        [PERMISSION_GROUP_PROJECT]: 30000,
        [PERMISSION_GROUP_USER]: 40000,
        [PERMISSION_GROUP_FILES]: 50000,
        [PERMISSION_GROUP_SETTINGS]: 60000,
        [PERMISSION_GROUP_DRAWING]: 70000,
        [PERMISSION_GROUP_DOCUMENTS]: 80000,
        [PERMISSION_GROUP_CATEGORIES]: 90000,
    },
    type: {
        [PERMISSION_TYPE_ASSIGNEE]: 100,
        [PERMISSION_TYPE_OWNER]: 200,
        [PERMISSION_TYPE_ALL]: 300,
        [PERMISSION_TYPE_PROJECT]: 400,
        [PERMISSION_TYPE_SELF]: 500,
    },
    action: {
        [PERMISSION_ACTION_VIEW]: 1,
        [PERMISSION_ACTION_CREATE]: 2,
        [PERMISSION_ACTION_EDIT]: 3,
        [PERMISSION_ACTION_MANAGE]: 4,
    },
};
